import ReactGA from "react-ga4";

export const initGA4 = ({ measurementId, userId }) => {

    if (!measurementId) {
        console.error("GA4 measurementId is required!");
        return;
    }

    if (ReactGA.ga && ReactGA.ga.getAll && ReactGA.ga.getAll().length > 0) {
        console.log("GA4 already initialized, skipping...");
        return;
    }

    ReactGA.initialize([
        {
            trackingId: measurementId,
            gaOptions: {
                userId: userId ?? undefined,
            },
        },
    ]);

    console.log("GA4 initialized:", measurementId);

};

export const logEventGA4 = (eventName, params = {}) => {
    ReactGA.event(eventName, params);
    console.log("GA4 event:", eventName, params);
};

export const logPageViewGA4 = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
    console.log("GA4 pageview:", path);
};
